import React from 'react';
import { Button, Typography, Space } from 'antd';
import {
  multiSelectValuesAtom,
  multiSelectResponseAtom,
  careProviderConfiguration,
} from '../../store';
import { UserResponseType } from '../../models/questionnaire.interface';
import { useAtom } from 'jotai';
import { COLORS } from 'themes/colors';

const { Text } = Typography;

interface MulitSelectProps {
  recordAnswer: (userResponse: UserResponseType) => void;
  questionId: number;
  isBeingEdited: boolean;
  disabled?: boolean;
}

const MultiSelect: React.FC<MulitSelectProps> = ({
  recordAnswer,
  disabled = false,
}) => {
  const [multiSelectValues, setMultiSelectValues] = useAtom(
    multiSelectValuesAtom,
  );
  const [multiSelectResponse] = useAtom(multiSelectResponseAtom);
  const [careProviderStyles] = useAtom(careProviderConfiguration);

  const clearAnswers = () => {
    setMultiSelectValues([]);
  };

  const onSubmit = () => {
    recordAnswer(multiSelectResponse);
    clearAnswers();
  };

  const isDisabled = disabled || !multiSelectValues.length;

  return (
    <div style={{ display: 'flex', justifyContent: 'space-between' }}>
      <Space>
        <Button
          disabled={isDisabled}
          style={{
            boxShadow: 'none',
            backgroundColor: isDisabled
              ? 'white'
              : careProviderStyles.colorPrimary,
            color: COLORS.whiteL0,
          }}
          type="primary"
          size="small"
          onClick={clearAnswers}
          data-cy="deselect_all_button"
        >
          &#8722;
        </Button>
        <Text strong>{multiSelectValues.length} Selected</Text>
      </Space>

      <Button
        disabled={isDisabled}
        shape="round"
        style={{
          marginLeft: '20px',
          border: 'none',
        }}
        onClick={onSubmit}
        data-cy="multiselect_continue_button"
      >
        Continue
      </Button>
    </div>
  );
};

export default MultiSelect;
